import { HomeIcon, ExploreIcon, SearchIcon, BasketIcon, MoreIcon } from '../../icons/NavIcons';
import { Badge, Bar, IconWrapper, TabItem, TabLabel } from './MobileTabBar.styles';
import type { MobileTabBarProps } from './MobileTabBar.types';

const mobileIconMap = {
  home: HomeIcon,
  explore: ExploreIcon,
  search: SearchIcon,
  basket: BasketIcon,
  more: MoreIcon,
} as const;

export function MobileTabBar({ items, navigationLabel = 'Main navigation' }: MobileTabBarProps) {
  return (
    <Bar aria-label={navigationLabel}>
      {items.map((item) => {
        const IconComponent = mobileIconMap[item.icon];
        return (
          <TabItem
            key={item.id}
            $active={item.active}
            onClick={item.onClick}
            type="button"
            aria-label={item.label}
          >
            <IconWrapper>
              <IconComponent size={22} />
              {item.badge != null && item.badge > 0 && <Badge>{item.badge}</Badge>}
            </IconWrapper>
            <TabLabel>{item.label}</TabLabel>
          </TabItem>
        );
      })}
    </Bar>
  );
}
